import Checkbox from './Checkbox';
import Group from './Group';
export { CheckboxProps } from './Checkbox';
export { CheckboxGroupProps, CheckboxOptionType } from './Group';
Checkbox.Group = Group;
export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.tsx